import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { BackstageLoggerDefaultArgs } from '../../../constants';
import * as D from '../../../deps';
import { withCuratorButtonControls } from '../../common/CuratorButtonControls';

// @ts-expect-error TS(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
export const CuratorSidebarButtons = props => {
  const {
    curatorPandoraId,
    isPaused,
    isCurrentlyPlayingContent,
    hasPlayableContent,
    playOnClick,
    pauseOnClick,
    onShareClick,
    curatorName,
  } = props;

  const integrationData = {
    ...BackstageLoggerDefaultArgs.controlBar,
    curatorPandoraId,
  };

  // @ts-expect-error TS(7034) FIXME: Variable 'hiddenButtons' implicitly has type 'any[... Remove this comment to see the full message
  const hiddenButtons = [];
  const getHiddenButtons = (): string[] => {
    if (!props.isCuratorDeepLinkingEnabled) {
      hiddenButtons.push(D.ButtonRowType.SHARE);
    }
    // @ts-expect-error TS(7005) FIXME: Variable 'hiddenButtons' implicitly has an 'any[]'... Remove this comment to see the full error message
    return hiddenButtons;
  };

  return (
    <D.AppContextIntegrationData data={integrationData}>
      <D.ButtonRowWithLogger
        // @ts-expect-error TS(2322) FIXME: Type '{ playOnClick: (...args: any[]) => void; pau... Remove this comment to see the full error message
        buttonTextType={D.ButtonTextType.PLAY}
        disabledButtons={!hasPlayableContent ? [D.ButtonRowType.PLAY] : []}
        hiddenButtons={getHiddenButtons()}
        isSidebar={true}
        entityName={curatorName}
        pauseOnClick={isCurrentlyPlayingContent && !isPaused ? pauseOnClick : noop}
        playOnClick={!isCurrentlyPlayingContent || isPaused ? playOnClick : noop}
        shareOnClick={onShareClick}
      />
    </D.AppContextIntegrationData>
  );
};

CuratorSidebarButtons.propTypes = {
  playablePandoraId: PropTypes.string,
  curatorPandoraId: PropTypes.string,
  curatorName: PropTypes.string,
  hasPlayableContent: PropTypes.bool,
  playableContentType: PropTypes.string,
  isCurrentlyPlayingContent: PropTypes.bool,
  isPaused: PropTypes.bool,
  playOnClick: PropTypes.func,
  pauseOnClick: PropTypes.func,
  onShareClick: PropTypes.func,
};

// @ts-expect-error TS(7006) FIXME: Parameter 'state' implicitly has an 'any' type.
export function mapStateToProps(state, ownProps) {
  const isPlayableContentStation = ownProps.playableContentType === D.PandoraTypes.STATION;
  const playablePandoraId = isPlayableContentStation
    ? D.getStationIdByFactoryId(state, ownProps.playablePandoraId)
    : ownProps.playablePandoraId;
  return {
    isCuratorDeepLinkingEnabled: D.Utils.TunerVars.curatorDeepLinkingEnabled(state),
    isCurrentlyPlayingContent: D.getInDomain('playback.utils.isSourcePlayingCurrently', false)(
      state,
      playablePandoraId,
    ),
    isPaused: !D.getInDomain('playback.utils.isAudioPlaying', false)(state),
    onDemandIsEnabled: D.Utils.Listener.hasPremiumFeatures(state),
    showPremiumAccess: D.Utils.Listener.showPremiumAccess(state),
  };
}

const enhance = compose(withCuratorButtonControls, connect(mapStateToProps));

export default enhance(CuratorSidebarButtons);
